export default __webpack_public_path__ + "static/media/card-background-default.083a9ce4.png";